import type { ButtonHTMLAttributes, FunctionComponent } from 'react';
import React from 'react';
import cx from 'classnames';
import { CanonicalCard } from '@trello/test-ids';
import styles from './Buttons.less';
import { OverflowButtonHorizontalIcon } from '../icons/OverflowButtonHorizontalIcon';
import { OverflowButtonVerticalIcon } from '../icons/OverflowButtonVerticalIcon';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {}

export const Button: FunctionComponent<ButtonProps> = ({
  className,
  ...props
}) => <button className={cx(styles.button, className)} {...props} />;

export const ButtonLink: FunctionComponent<ButtonProps> = (props) => (
  <span className={styles.linkButtonContainer}>
    <button className={styles.linkButton} {...props} />
  </span>
);

interface IconButtonProps extends ButtonProps {
  icon: React.ReactNode;
}

export const Icon: FunctionComponent = (props) => (
  <span className={styles.icon} {...props} />
);

export const IconButton: FunctionComponent<IconButtonProps> = ({
  children,
  icon,
  ...buttonProps
}) => (
  <Button {...buttonProps}>
    <span className={styles.iconContainer}>{icon}</span>
    {children}
  </Button>
);

interface OverflowButtonProps extends ButtonProps {
  isVertical?: boolean;
}

export const OverflowButton: FunctionComponent<OverflowButtonProps> = ({
  isVertical,
  className,
  ...buttonProps
}) => (
  <Button
    className={cx(styles.overflowButton, className)}
    data-test-class={CanonicalCard.OverflowDetailsButton}
    {...buttonProps}
  >
    <span className={styles.overflowIcon}>
      {isVertical ? (
        <OverflowButtonVerticalIcon />
      ) : (
        <OverflowButtonHorizontalIcon />
      )}
    </span>
  </Button>
);
